import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const useLanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const lang = urlParams.get('lang');

    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [location, i18n]);

  return {
    currentLanguage: i18n.language,
  };
};
